import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Modal, Button, Container, Navbar, Nav } from 'react-bootstrap';
import { useModal } from '../backend/ModalContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Header.css';

function Header() {
    const { isModalOpen, closeModal } = useModal();
    const isInIframe = window.self !== window.top;
    const logoLink = isInIframe ? '/' : 'https://psicopatici.com';

    return (
        <>
            <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} />

            <Navbar
                expand="lg"
                className="navbar-custom"
                style={{
                    position: "fixed",
                    top: 0,
                    width: "100%",
                    zIndex: 1000,
                    backgroundColor: "#000",
                    height: "80px"
                }}
            >
                {/* Aggiunta la classe flex-nowrap per evitare che il bottone vada sotto */}
                <Container className="d-flex align-items-center justify-content-between flex-nowrap position-relative">

                    {/* 1. Spaziatore a sinistra (invisibile) per bilanciare il flexbox su desktop */}
                    <div className="login-spacer d-none d-lg-block"></div>

                    {/* 2. LOGO (Sempre centrato) */}
                    {!isInIframe && (
                        <Link className="navbar-brand-centered" to={logoLink}>
                            <img
                                className="logo-img"
                                src="https://cdn.psicopaticiservice.com/logo/materialeweb/logo-white.png"
                                alt="logo"
                            />
                        </Link>
                    )}

                    {/* 3. BOTTONE LOGIN (Sempre a destra) */}
                    <div className="login-container">
                        <a
                            href="https://app.psicopatici.com/sign-in"
                            className="btn btn-light fw-bold login-btn-header"
                        >
                            Accedi
                        </a>
                    </div>

                </Container>
            </Navbar>

            {/* Modal rimasto invariato */}
            <Modal show={isModalOpen} onHide={closeModal} fullscreen className="custom-modal">
                <Modal.Header closeButton style={{ borderBottom: 'none', position: 'relative' }}>
                    <Modal.Title>Diventa Partner</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/* Contenuto Form */}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={closeModal}>Chiudi</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default Header;